import React from 'react';

const ChameleonEnabler = () => {
    return (
        <div
            data-chameleonenabled="true"
            data-testid="chameleon-enabler"
            // If we use `display: none` or `opacity: 0` Chameleon won't
            // detect the tag
            style={{ height: 0, width: 0 }}
        />
    );
};

export default ChameleonEnabler;
